import React, { useState, useEffect } from "react";
import { getLoggedInUser } from "../helpers";
import {
  Container,
  Card,
  CardBody,
  Col,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";
import ReactTable from "react-table";
import { connect } from "react-redux";
import { betSlipService } from "../redux/betslip/services";
import swal from "sweetalert";
import Loader from "./Loader/Loader";
import config from "react-global-configuration";
import KycUpdate from "../pages/KycUpdate";
import DateFormet from "../dateFormet"; // Import the class
import { RxCross2 } from "react-icons/rx";
import { useTranslation } from "react-i18next";

const KycDocList = (props) => {
  const [user] = useState(getLoggedInUser());
  const [isLoading, setIsLoading] = useState(false);
  const { t } = useTranslation();
  const [totalItemCount, setTotalItemCount] = useState(0);
  const [totalPageCount, setTotalPageCount] = useState(-1);
  const [pageSize, setPageSize] = useState(10);
  const [pageSizeOptions] = useState([10, 20, 30, 40, 50, 100]);
  const [currentPage, setCurrentPage] = useState(0);
  const [tableSorting, setTableSorting] = useState([
    { columnName: "title", direction: "asc" },
  ]);
  const [tableFilter, setTableFilter] = useState([]);
  const [bettingLimit, setBettingLimit] = useState("");
  const [resMessage, setResMessage] = useState("");
  const [right, setRight] = useState(false);
  const [wrong, setWrong] = useState(false);
  const [userList, setUserList] = useState([]);
  const [walletList, setWalletList] = useState([]);
  const [documents, setDocuments] = useState([]);
  const [totalBalance, setTotalBalance] = useState("");
  const [totalDeposit, setTotalDeposit] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpenOne, setIsModalOpenOne] = useState(false);
  const [menu, setMenu] = useState(false);

  useEffect(() => {
    loadRecordsTables();
    loadUserWalletTables();
  }, [currentPage, pageSize, tableSorting, tableFilter]);

  const loadRecordsTables = () => {
    const reqData = { guid: user.guid };
    setIsLoading(true);
    betSlipService
      .LimitDetails(reqData)
      .then((res) => {
        let data = res[0];
        setUserList(data);
        setIsLoading(false);
      })
      .catch(() => {
        setIsLoading(false);
      });
  };

  const handleValidSubmit = (event, values) => {
    setIsLoading(true);
    let formData = new FormData();
    formData.append("betting_limit", values.betting_limit);
    formData.append("password", values.password);
    formData.append("guid", user.guid);

    betSlipService
      .updateLimit(formData, config)
      .then((res) => {
        if (res.message) {
          setRight(true);
          setResMessage(res.message);
        } else {
          setWrong(true);
          setResMessage(res.error);
        }
        setIsLoading(false);
      })
      .catch(() => {
        setIsLoading(false);
      });
  };

  const loadUserWalletTables = () => {
    const columnSorting = tableSorting[0];
    let curPage = currentPage + 1;
    const reqData = {
      id: user.id,
      page_size: pageSize,
      page: curPage,
      search: tableFilter,
      sort_by: columnSorting?.columnName,
      sort_order: columnSorting?.direction === "desc" ? "desc" : "asc",
    };

    setIsLoading(true);
    betSlipService
      .userkyclist(reqData)
      .then((response) => {
        setWalletList(response.data);
        setTotalItemCount(response.total);
        setTotalPageCount(response.last_page);
        setTotalBalance(response.total_balance);
        setTotalDeposit(response.total_deposit);
        setIsLoading(false);
      })
      .catch(() => {
        setIsLoading(false);
      });
  };
  useEffect(() => {
    if (isModalOpenOne === false) {
      loadUserWalletTables();
    }
  }, [isModalOpenOne]);

  const handlePerRowsChange = (perPage) => {
    setPageSize(perPage);
  };

  const handlePageChange = (currentPage) => {
    setCurrentPage(currentPage);
  };

  const handleSortChange = (tableSorting) => {
    let sortVal = tableSorting.map((value) => ({
      columnName: value.id,
      direction: value.desc ? "desc" : "asc",
    }));
    setTableSorting(sortVal);
  };

  const handleFilterChange = (tableFilter) => {
    setTableFilter(tableFilter);
  };

  const handleOpenModal = (row) => {
    const reqData = { id: row.id };
    betSlipService
      .userkyclistimage(reqData)
      .then((response) => {
        setDocuments(response.data.document_name);
        setIsModalOpen(true);
      })
      .catch(() => {
        setIsModalOpen(false);
      });
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const toggleModalOne = () => {
    setIsModalOpenOne(!isModalOpenOne);
  };

  const renderRedirectToRoot = () => {};

  const Hamburger = () => {
    if (menu == false) {
      setMenu(true);
    } else {
      setMenu(false);
    }
  };
  const onTrigger = (event) => {
    props.parentCallback(true);
  };

  let loading = isLoading ? <Loader /> : null;

  return (
    <React.Fragment>
      <div className="account-pages">
        <div className="withdraw-request-popup">
          <div className="withdraw-request-popup1">
            <Modal className="withdraw-request-popup" isOpen={isModalOpenOne}>
              <ModalBody>
                <p onClick={toggleModalOne}>
                  <RxCross2 className="close-btn" />
                </p>
                <KycUpdate setIsModalOpenOne={setIsModalOpenOne} />
              </ModalBody>
            </Modal>
            <Modal
              style={{}}
              className="withdraw-request-popup"
              isOpen={isModalOpen}
              onRequestClose={handleCloseModal}
            >
              <ModalBody>
                <p onClick={handleCloseModal}>
                  <RxCross2 className="close-btn" />
                </p>
                <h3 className="text-center text-black text-white">
                  {t("userProfile.uploadDocument.modal.userDocument")}
                </h3>
                <div>
                  {documents.map((image) => (
                    <div>
                      <a
                        className="download-data"
                        style={{
                          display: "inline-block",
                          width: "100%",
                          // padding: "15px",
                          textAlign: "center",
                          border: "2px solid #f5048d",
                          margin: "25px 0",
                          borderRadius: "5px",
                        }}
                        download={image}
                        //   href={image}
                      >
                        <a
                          style={{
                            display: "inline-block",
                            width: "100%",
                            padding: "25px 15px",
                            // textAlign: "center",
                            // border: "2px solid #000",
                            // margin: "25px 0",
                            // borderRadius: "5px",
                          }}
                          target="_blank"
                          href={image}
                          download="document.png" // Set the desired filename and file extension
                        >
                          <embed
                            src={image}
                            alt="casino"
                            max-width="100%"
                            width="100%"
                          />
                        </a>
                      </a>
                    </div>
                  ))}
                </div>
                <div></div>
                <div className="col-md-12 center">
                  {/* <button className="documents-download" onClick={handleCloseModal}>Close</button> */}
                  <button
                    className="cstm_btn2 active mt-3"
                    onClick={handleCloseModal}
                  >
                    {" "}
                    {t("userProfile.uploadDocument.modal.close")}
                  </button>
                </div>
              </ModalBody>
            </Modal>
          </div>
        </div>
        <section className="dashboard-section padding-top padding-bottom">
          <Container>
            <Row>
              <Col className="col-lg-12 col-md-12 col-sm-12">
                <div className="user-toggler-wrapper d-flex align-items-center d-lg-none">
                  <h4 className="title m-0">Menu</h4>
                  <div className="user-toggler" onClick={() => onTrigger()}>
                    <i className="las la-sliders-h"></i>
                  </div>
                </div>
                <Col
                  style={{ display: "flex", justifyContent: "end" }}
                  className="col-lg-12 col-md-12 col-sm-12 text-right"
                >
                  <a
                    type="button"
                    onClick={toggleModalOne}
                    className="casino-btn-kyc"
                  >
                    {t("userProfile.uploadDocument.title")}
                  </a>
                </Col>
                <div className="table--responsive--md mt-3">
                  <Card style={{ minHeight: "425px" }}>
                    <CardBody className="bg-dark1 user-data">
                      <ReactTable
                        data={walletList}
                        columns={[
                          {
                            Header: t("userProfile.uploadDocument.columns.id"),
                            accessor: "id",
                            filterable: false,
                            sortable: false,
                            className: "text-center",

                            Cell: (row) => (
                              <div
                                style={{
                                  whiteSpace: "normal",
                                  wordWrap: "break-word",
                                }}
                              >
                                {row.value ? row.value : "--"}
                              </div>
                            ),
                          },
                          {
                            Header: t(
                              "userProfile.uploadDocument.columns.documentName",
                            ),
                            accessor: "name",
                            filterable: false,
                            sortable: false,
                            className: "text-center",

                            Cell: (row) => (
                              <div
                                style={{
                                  whiteSpace: "normal",
                                  wordWrap: "break-word",
                                }}
                              >
                                {row.value ? row.value : "--"}
                              </div>
                            ),
                          },
                          {
                            Header: t(
                              "userProfile.uploadDocument.columns.viewDocument",
                            ),
                            accessor: "id",

                            filterable: false,
                            sortable: false,
                            className: "text-center",
                            Cell: (row) => (
                              <div className="btn-group mb-2 casino-btn1">
                                {
                                  <a
                                    type="button"
                                    style={{
                                      color: "#fff",
                                      borderRadius: "10px",
                                    }}
                                    onClick={() =>
                                      handleOpenModal(row.original)
                                    }
                                  >
                                    {t(
                                      "userProfile.uploadDocument.columns.view",
                                    )}
                                  </a>
                                }
                              </div>
                            ),
                          },
                          {
                            Header: (
                              <div
                                style={{
                                  whiteSpace: "normal",
                                  wordWrap: "break-word",
                                }}
                              >
                                {t("userProfile.uploadDocument.columns.status")}
                              </div>
                            ),
                            accessor: "status",
                            filterable: false,
                            sortable: false,
                            className: "text-center",
                            Cell: (row) => {
                              let status;
                              switch (row.value) {
                                case 0:
                                  status = t(
                                    "userProfile.uploadDocument.actions.rejected",
                                  );
                                  break;
                                case 1:
                                  status = t(
                                    "userProfile.uploadDocument.actions.approved",
                                  );
                                  break;
                                case 2:
                                  status = t(
                                    "userProfile.uploadDocument.actions.pending",
                                  );
                                  break;
                                default:
                                  status = "";
                                  break;
                              }
                              return <span>{status}</span>;
                            },
                          },
                          {
                            Header: (
                              <div
                                style={{
                                  whiteSpace: "normal",
                                  wordWrap: "break-word",
                                }}
                              >
                                {t("userProfile.uploadDocument.columns.reason")}
                              </div>
                            ),
                            accessor: "reason",
                            filterable: false,
                            sortable: false,
                            className: "text-center",
                            Cell: (row) => (
                              <div
                                style={{
                                  whiteSpace: "normal",
                                  wordWrap: "break-word",
                                }}
                              >
                                {row.value ? row.value : "--"}
                              </div>
                            ),
                          },
                          {
                            Header: (
                              <div
                                style={{
                                  whiteSpace: "normal",
                                  wordWrap: "break-word",
                                }}
                              >
                                {t(
                                  "userProfile.uploadDocument.columns.uploadedAt",
                                )}
                              </div>
                            ),
                            accessor: "created_at",
                            filterable: false,
                            sortable: false,
                            className: "text-center",
                            width: 120,
                            Cell: (row) => (
                              <div
                                style={{
                                  whiteSpace: "normal",
                                  wordWrap: "break-word",
                                }}
                              >
                                {row.value
                                  ? DateFormet.formatDate(row.value)
                                  : "--"}
                              </div>
                            ),
                          },
                        ]}
                        loading={isLoading}
                        defaultPageSize={pageSize}
                        pageSizeOptions={pageSizeOptions}
                        sortable={true}
                        multiSort={false}
                        resizable={true}
                        filterable={true}
                        onSortedChange={handleSortChange}
                        onPageSizeChange={handlePerRowsChange}
                        onPageChange={handlePageChange}
                        onFilteredChange={handleFilterChange}
                        manual={true}
                        minRows="0"
                        pages={totalPageCount}
                        showPagination={walletList.length > 0} // Conditionally hide pagination
                        // defaultPageSize={10}
                        // minRows={0}
                        // noDataText='No Records'
                        page={currentPage}
                        // pages={totalPageCount}
                        // onPageChange={handlePageChange}
                        // onPageSizeChange={handlePerRowsChange}
                        // onSortChange={handleSortChange}
                        // onFilteredChange={handleFilterChange}
                        //
                        NoDataComponent={() => (
                          <div style={{ textAlign: "center", padding: "1rem" }}>
                            {t(
                              "userProfile.uploadDocument.columns.emptySectionMessage",
                            )}
                          </div>
                        )}
                      />
                    </CardBody>
                  </Card>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
      </div>
      {loading}
    </React.Fragment>
  );
};

export default connect((state) => state, null)(KycDocList);
